module.exports = __webpack_public_path__ + "img/right.9083af8f.svg";